import api from "../../config/Api";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const sellerLogin = createAsyncThunk<any, { loginRequest: any; navigate: (path: string) => void }>(
    "sellerAuth/sellerLogin",
    async ({ loginRequest, navigate }, { rejectWithValue }) => {
        try {
            const response = await api.post("/sellers/login", loginRequest);
            //console.log("Login success:", response.data);
            
            const jwt = response.data?.jwt;
            if (jwt) {
                localStorage.setItem("jwt", jwt);
                navigate("/seller");
            }
            return response.data;
        } catch (error: any) {
            //console.error("Seller login error:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);

export const registerSeller = createAsyncThunk<any, { sellerData: any; navigate: (path: string) => void }>(
    "sellerAuth/registerSeller",
    async ({ sellerData, navigate }, { rejectWithValue }) => {
        try {
            // 1. Register seller directly
            const response = await api.post("/sellers/register-seller", sellerData);
            //console.log("Registration success:", response.data);

            // 2. If backend returns JWT directly on registration, store and navigate
            const jwt = response.data?.jwt;
            if (jwt) {
                localStorage.setItem("jwt", jwt);
                navigate("/seller");
            } else {
                // Otherwise auto-login using the registered email & password
                const loginRes = await api.post("/sellers/login", {
                    email: sellerData.email,
                    password: sellerData.password
                });
                if (loginRes.data?.jwt) {
                    localStorage.setItem("jwt", loginRes.data.jwt);
                    navigate("/seller");
                }
            }

            return response.data;
        } catch (error: any) {
            console.error("Registration error:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    }
);